import { render, staticRenderFns } from "./ShoplistFilter.vue?vue&type=template&id=496ce312&"
import script from "./ShoplistFilter.vue?vue&type=script&lang=js&"
export * from "./ShoplistFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496ce312')) {
      api.createRecord('496ce312', component.options)
    } else {
      api.reload('496ce312', component.options)
    }
    module.hot.accept("./ShoplistFilter.vue?vue&type=template&id=496ce312&", function () {
      api.rerender('496ce312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/ShoplistFilter.vue"
export default component.exports